export function PageContainer({ children }: React.PropsWithChildren) {
  return (
    <div data-component="PageContainer" className="flex flex-col gap-4 px-6 py-[6em] lg:gap-8 lg:px-14 lg:py-[6em]">
      {children}
    </div>
  );
}
